module.exports = __webpack_public_path__ + "static/button1-3530f9f383faab5cb2f0eb892c618897.png";